import styled from '@emotion/styled';

export const StyledContainer = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: 40px;
`;

export const StyledIconBox = styled.div`
    background-color: ${(props) => props.theme.colors.main2};
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    flex-basis: 60px;
    flex-grow: 0;
    flex-shrink: 0;
    position: relative;
    margin-top: 5px;

    svg {
        margin-left: -10px;
        height: 20px;
        width: 20px;
        fill: ${(props) => props.theme.shades.white};
    }

    &:after {
        content: '';
        border-style: solid;
        border-width: 20px 10px 20px 0px;
        border-color: transparent ${(props) => props.theme.shades.white} transparent transparent;
        position: absolute;
        right: -1px;
        top: 0;
    }
`;

export const StyledText = styled.div`
    p {
        font-size: ${(props) => props.theme.fontSize.copyTextL};
        line-height: 22px;
        margin: 0;
        padding-left: 7px;
    }
`;
